import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, NavigationEnd, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { GlobalUser } from 'src/app/core/models/global.user.model';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { UserService } from 'src/app/core/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  loggedUser: GlobalUser = new GlobalUser();
  lastUrl: string = '';

  constructor(private userService: UserService, private helpersService: HelpersService, private router: Router) {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe((e: any) => (this.lastUrl = e.url));

    this.userService
      .getLoggedUser()
      .pipe(take(1))
      .subscribe((user) => {
        this.loggedUser = user;
      });
  }

  isLogged(): boolean {
    return this.helpersService.getDsAuthJWTToken().isValid();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean | UrlTree {
    if (this.isLogged()) {
      return true;
    } else {
      return this.router.parseUrl('/auth');
    }
  }
}
